var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer-link-list-item',{attrs:{"href":_vm.getUrl}},[_c('base-icon-text',{attrs:{"icon":_vm.getIcon}},[_vm._v(_vm._s(_vm.displayValue))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }